import React from "react";
import "./members.css";
import Profile from "../components/profile";
import Breonna from "../profiles/Breonna.jpg"
import Julie from "../profiles/julie.jpg";
import Mark from "../profiles/mark.jpg";
import Helen from "../profiles/helen.jpg";
import Tonia from "../profiles/ToniaL2026.jpeg"
import Phillip from "../profiles/Phillip.jpg"
import Lana from "../profiles/lanab2026.jpeg"
import Kathy from "../profiles/kathy.jpg";
import Jim from '../profiles/jim.jpg';
import Grace from "../profiles/grace.jpg"
import mailIcon from "../icons/mailIcon.png"
import Benine from "../profiles/bernie.jpeg"
import Abisai from "../profiles/Abisai Perez-Gomez 2026.jpg"
class members extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="parentContainerMembers">

        <h1 className="pageTitle">Board Members</h1>
        
        <Profile
          Name={"Mark Crouchet"}
          Description={"Board Chairman"}
          Image={Mark}
          width={"25%"}
          height={"25%"}
        />
        <Profile
          Name={"Julie Schilling"}
          Description={"Vice-Chair"}
          Image={Julie}
          width={"25%"}
          height={"25%"}
        />
        <Profile
          Name={"Phillip Fluaitt"}
          Description={"Treasurer"}
          Image={Phillip}
          width={"25%"}
          height={"25%"}
        />
          <Profile
          Name={"Lana Burwell"}
          Image={Lana}
          Description={"Secretary"}
          width={"25%"}
          height={"25%"}
        />
        <Profile
          Name={"Helen Canatsey"}
          Description={"Board Member"}
          Image={Helen}
          width={"25%"}
          height={"25%"}
        />
       

         <Profile
          Name={"Tonia Latham"}
          Description={"Board Member"}
          Image={Tonia}
          width={"25%"}
          height={"25%"}
        />
            <Profile
        Name={"Benine McDonnell"}
          Description={"Board Member"}
          Image={Benine}
          width={"25%"}
          height={"25%"}>
        </Profile>
        <Profile
        Name={"Abisai Perez-Gomez"}
          Description={"Student Board Representative"}
          Image={Abisai}
          width={"25%"}
          height={"25%"}>
        </Profile>
        
        <Profile
        Name={"Jim Honeyford"}
          Description={"Honorary Board Member"}
          Image={Jim}
          width={"25%"}
          height={"25%"}>
        </Profile>
        <Profile
        Name={"Kathy Cluck"}
          Description={"Honorary Board Member"}
          Image={Kathy}
          width={"25%"}
          height={"25%"}>
        </Profile>
        <Profile
        Name={"Breonna Latham"}
          Description={"Board Advisor"}
          Image={Breonna}
          width={"25%"}
          height={"25%"}>
        </Profile>
       
      
        <div className="emailContainer">  <img style={{margin:'5px'}} src={mailIcon} alt="mailIcon"></img> <div>friends.uglcc@gmail.com</div></div>
      </div>
    );
  }
}
export default members;
